export default function ReferralTree() {
  return <div className="text-xl font-semibold">Your Referral Network</div>;
}
